import { AlertTriangle, RefreshCw } from 'lucide-react'

import { Button } from '@krp/ui-kit'

import '../../../shared/uc1b/journals.css'
import { QueryState } from '../../../shared/uc1b/QueryState'
import { ReceiptsBrowser, type ReceiptsBrowserExtras } from './ReceiptsBrowser'
import { RequestProgress } from './RequestProgress'
import type { ReceiptsActions, ReceiptsVm } from '../model/types'
import './receipts.css'

/**
 * Вкладка «Статистика по продажам» кабинета AQSI (RP-FB74): выручка за месяц и за день, приход, возвраты, итог, график по
 * дням и прогноз месяца — сверху общей основы `ReceiptsBrowser` (те же дерево, фильтры и список чеков, что в «Чеки»). Доступ —
 * по праву `sales.read` (окно в `registerWindows`): сводки видят не все, кто видит сами чеки. Экран получает vm и actions и
 * больше ничего.
 */
export function SalesStatisticsScreen({ vm, actions }: { vm: ReceiptsVm; actions: ReceiptsActions }) {
  const stats = vm.stats
  const statsFailed = ['unauthorized', 'forbidden', 'unavailable', 'error'].includes(stats.query.status)
  const extras: ReceiptsBrowserExtras = {
    stats: stats.items,
    statsBusy: stats.query.status === 'loading',
    notices: statsFailed && <QueryState query={stats.query} emptyText="" onRetry={actions.reload} />,
    trend: stats.trend,
    ...(stats.periodTrend !== undefined ? { periodTrend: stats.periodTrend } : {}),
    trendBusy: stats.trendQuery?.status === 'loading' || stats.trendQuery?.status === 'idle',
    // «Обновить» перечитывает итоги, не убирая прочитанное: загрузка видна на сегодняшнем столбце.
    todayBusy: stats.trendQuery?.refreshing === true,
    ...(stats.trendQuery?.error != null
      ? {
          trendMessage: `${stats.trendQuery.error.message} · Код: ${stats.trendQuery.error.code}${
            stats.trendQuery.error.correlationId !== null ? ` · Запрос: ${stats.trendQuery.error.correlationId}` : ''
          }`,
        }
      : {}),
  }
  return (
    <section className="aqsi-journal" aria-labelledby="aqsi-sales-statistics-title">
      <header className="aqsi-journal__head krp-sticky-refresh">
        <h2 id="aqsi-sales-statistics-title">Статистика по продажам · {vm.title}</h2>
        <Button variant="ghost" icon={<RefreshCw size={16} aria-hidden="true" />} busy={vm.list.refreshing || stats.query.refreshing || stats.trendQuery?.refreshing === true} onClick={actions.reload}>
          Обновить
        </Button>
      </header>
      {vm.summaryWarning !== null && (
        <p className="aqsi-journal__note" data-tone="warning" role="status">
          <AlertTriangle size={16} aria-hidden="true" />
          <span>{vm.summaryWarning}</span>
        </p>
      )}
      <RequestProgress query={stats.query} what="Итоги" />
      <ReceiptsBrowser vm={vm} actions={actions} extras={extras} receipts={false} multiDayText="" />
    </section>
  )
}
